import { createPolylineGeometry } from '../../providers/esri/geometry/polyline';

/**
 * Creates and returns a polyline instance based on the map provider
 * @param {Object} mapObject - map object
 * @param {Object} options - options for the polyline
 */
const createPolyline = ({ mapObject, options = {} }) => {
  return createPolylineGeometry({
    mapObject,
    configs: options,
  }).then(polylineGeometry => {
    const polyline = {
      instance: polylineGeometry.polyline,
      ...(options.custom ? { custom: { ...options.custom } } : {}),
    };
    return polyline;
  });
};

export default createPolyline;
